import { render } from "./ViewPost.vue?vue&type=template&id=de7fa658&scoped=true"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"

import "./ViewPost.vue?vue&type=style&index=0&id=de7fa658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7fa658"]])

export default __exports__